import React, { useState } from 'react';
import { Menu, MenuItem, Sidebar } from 'react-pro-sidebar';
import { useSelector } from 'react-redux';
import { sidebarValidPermission } from 'Util/Permissions';
import IntlMessages from 'Util/IntlMessages';
import SidebarIcon from './SidebarIcon';
import { NavLink, useLocation } from 'react-router-dom';
import NavLinks from './NavLinks';
import FieldAddUpdateDrawer from 'Components/FieldSidebar/components/FieldAddUpdateDrawer';
import BasicTextDialog from 'Components/Dialog/BasicTextDialog';

const SidebarKo = () => {
  const { user } = useSelector(state => state.authUser);
  const { navCollapsed } = useSelector(state => state.settings);
  const location = useLocation();
  const { newMenu } = useSelector(state => state.noty);
  const { defaultField } = useSelector(state => state.config);
  const [openFieldPopup, setOpenFieldPopup] = useState(false);
  const [openEmptyPopup, setOpenEmptyPopup] = useState(false);

  const isActive = path => location.pathname.startsWith(path);

  const renderMenuItem = ({ menu_title, menu_icon, path, type, badge }, key) => {
    const icon = SidebarIcon().icon.find(x => x.name === menu_icon).icon;
    const activeIcon = SidebarIcon().icon.find(x => x.name === menu_icon).activeIcon;

    const isNew = type && Array.isArray(type) && type.some(key => newMenu?.global?.[key] > 0 || newMenu?.field?.[key] > 0);

    return (
      <MenuItem
        onClick={e => {
          if (defaultField?.isFirstField) {
            e.stopPropagation();
            e.preventDefault();
            setOpenEmptyPopup(true);
            return;
          }
        }}
        className='sidebar-menu-item'
        key={key}
        icon={<img {...(isActive(path) && activeIcon ? activeIcon : icon)} alt={menu_title} />}
        component={<NavLink to={path} />}
      >
        <span className='sidebar-menu-item-label-text'>
          <IntlMessages id={menu_title} />
          {isNew && <div className='sidebar-menu-item-new' />}
        </span>
        {badge && (
          <span className='sidebar-menu-item-badge'>
            <IntlMessages id={badge} />
          </span>
        )}
      </MenuItem>
    );
  };

  const renderMenu = (menu, key) => {
    return (
      <div key={key}>
        {menu.menu_title && (
          <div className='sidebar-menu-title'>
            <IntlMessages id={menu.menu_title} />
          </div>
        )}
        <Menu className='sidebar-menu'>{menu.children.filter(x => sidebarValidPermission(user, x.path)).map(renderMenuItem)}</Menu>
        {menu.bottom_line && <div className='sidebar-menu-bottom-line' />}
      </div>
    );
  };

  return (
    <>
      <Sidebar collapsed={navCollapsed} className='main-sidebar-ko'>
        <div style={{ padding: '20px 15px' }}>{NavLinks.links.map(renderMenu)}</div>
      </Sidebar>
      <FieldAddUpdateDrawer
        open={openFieldPopup}
        onClose={() => {
          setOpenFieldPopup(false);
        }}
      />
      <BasicTextDialog
        open={openEmptyPopup}
        onClose={() => {
          setOpenEmptyPopup(false);
        }}
        titleId='field.add.update.empty.title'
        subTitleId='field.add.update.empty.sub'
        closeId='button.close'
        confirmId='field.add.update.empty.button'
        onConfirm={() => {
          setOpenEmptyPopup(false);
          setOpenFieldPopup(true);
        }}
      />
    </>
  );
};

export default SidebarKo;
